import {
    FETCH_CUSTOMER_LINKS,
    REFRESH_CUSTOMER_LINKS,
} from "../constants";

const customerLinkReducer = (state = {
    total: 0,
    data: [],
    queryOptions: {

    }
}, action) => {
    switch (action.type) {
        case FETCH_CUSTOMER_LINKS:
            return {
                ...state,
                total: action.data.total,
                data: [...action.data.data],
                queryOptions: { ...action.queryOptions },
            }
        case REFRESH_CUSTOMER_LINKS:
            return {
                ...state,
                total: action.data.total,
                data: [...action.data.data],
            }
        default:
            return state
    }
}

export default customerLinkReducer